<template>
  <q-linear-progress v-if="this.isFetching" indeterminate />
  <div class="grouping-modal">
    <ResidentialApartmentsList
      :floorsPlan="this.floorsPlan"
      :mode="this.data.mode"
      :updateData="this.updateData"
      :params="this.data?.params"
      :addData="this.data?.data"
    />
    <CustomModalFooter
      v-if="!!this.floorsPlan?.length && this.data?.mode !== 'grouping'"
      :onSubmit="this.onSubmit"
      class="grouping-modal__footer"
    />
  </div>
</template>

<script>
import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import { appActions } from "@/services/store/modules/app_module/app_actions";
import ResidentialApartmentsList from "@/views/ResidentialSettings/ResidentialApartmentsList.vue";
import { checkFlatFloor, duplicateFlatToFloors, duplicateFloorGroup, getEntranceApartments } from "@/views/ResidentialSettings/services";

export default {
  name: "residential-grouping",
  components: { CustomModalFooter, ResidentialApartmentsList },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      isFetching: false,
      selected: {},
      floorsPlan: []
    };
  },
  methods: {
    async getData() {
      this.isFetching = true;
      const res = await getEntranceApartments(this.data?.params)
      this.isFetching = false;
      if(!res) return
      this.floorsPlan = res?.data
    },
    async handleDuplicateFloorGroup() {
      const body = {
        floor_map_id_from: this.data?.params?.floor_map_id,
        floor_arr: this.floorsPlan.filter(floor => floor.floor_map_id !== this.data?.params?.floor_map_id && floor.is_selected).map(floor => Number(floor.floor)),
      }
      return await duplicateFloorGroup(body, {floor_map_id: this.data?.params?.floor_map_id, project_type_id: this.data?.params?.project_type_id})
    },
    async handleDuplicateFlatFloorGroup() {
      const floorArr = []
      this.floorsPlan.forEach(floor => {
        if (floor.is_selected) {
          floor.flat?.forEach(apartment => {
            if(checkFlatFloor(floor, apartment, this.data?.data, true))
              floorArr.push(Number(floor.floor))
          })
        }
      })
      const body = {
        floor_flat_id_from: this.data?.data?.floor_flat_id,
        floor_arr: floorArr,
      }
      return await duplicateFlatToFloors(body, {floor_map_id: this.data?.params?.floor_map_id, project_type_id: this.data?.params?.project_type_id})
    },
    async onSubmit() {
      this.loading = true;
      const res = this.data?.mode === 'flat-grouping' ? await this.handleDuplicateFlatFloorGroup() : await this.handleDuplicateFloorGroup()
      this.loading = false;
      if(!res) return
      this.$store.commit(appActions.closeModal());
      this.showSucceedSnackbar()
      this.updateSubmitData(res)
    },
    updateData(res) {
      if(this.data?.mode === 'grouping') {
        this.floorsPlan = res?.data
      } else
        this.floorsPlan = res
      if(this.data?.mode === 'grouping')
        this.data.onSubmit && this.data.onSubmit(res)
    },
    updateSubmitData(res) {
      this.data.onSubmit && this.data.onSubmit(res)
    },
  },
  mounted() {
    this.getData()
  },
  setup() {
    const {showSucceedSnackbar} = useCustomSnackbar()
    return {showSucceedSnackbar}
  }
};
</script>

<style scoped lang="scss">
.grouping-modal {
  min-width: 300px;
}

@media (max-width: 991px) {
  .grouping-modal {
    min-width: 100%;
  }
}
.title {
  font-size: 14px;
  color: var(--ms-text);
  margin-bottom: 10px;
  line-height: 1;
  margin-top: 10px;
}
// футер прилипает к низу окна общим правилом (components/modal/index.vue)
</style>
